import { Component, Input, OnInit } from '@angular/core';
import { IProfileEntityDetail } from '@boma/supplier-portal/shared/entities';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { Store } from '@ngrx/store';

//TODO Unsure how we make this a little more dynamic in the sense of admin, supplier and website
//Other than removing the app component however I feel app component is a really nice way
//TO share the basic preferences throughout the application
import { take } from 'rxjs/operators';

@Component({
  selector: 'boma-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss'],
})
export class ReceiptComponent implements OnInit {
  @Input() sale: any;

  selectedOrganization: IProfileEntityDetail;

  constructor(public store: Store) {}

  ngOnInit(): void {
    this.store
      .select(getSelectedOrganizationInfo)
      .pipe(take(1))
      .subscribe((org) => {
        if (org) {
          this.selectedOrganization = org as IProfileEntityDetail;
        }
      });

    document.title =
      (this.sale.entity?.tradingName || '') +
      ' sales reference ' +
      this.sale.reference; // By updating the document title, we set the default filename when printing to PDF.
  }

  print() {
    window.print();
  }
}
